<template>
  <span>
  <!-- Page Heading -->
          <div class="d-sm-flex align-items-center justify-content-between mb-4" >
            <h2 class="h3 mb-0 text-gray-800">Settings</h2>
          </div>

          <div class="row justify-content-center">
             <div class="col-sm-12 col-md-10 col-lg-10">
                  <div class="card shadow mb-4">
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-info">Change Password</h6>
                        </div>
                        <div class="card-body">
                            <form @submit.prevent="changePassword">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">New Password</label>
                                    <input type="password" v-model="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputPassword1">Confirm Password</label>
                                    <input type="password" class="form-control" v-model="confirm_password" id="exampleInputPassword1">
                                </div>
                                 <p class="text-success" v-if="success">{{success}}</p>
                                 <p class="text-danger" v-if="error">{{error}}</p>
                                <button type="submit" class="btn btn-info">
                                    Submit
                                    <div class="spinner-grow" role="status" v-if="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </button>
                            </form>
                        </div>
                </div>
            </div>
          </div>
  </span>
</template>

<script>

export default {
  data() {
    return {
      password:'',
      confirm_password:'',
    }
  },
  methods: {
      changePassword(){
          this.$store.dispatch('changePassword', {password:this.password, confirm_password:this.confirm_password})
      }
  },
  computed:{
      users() {
        return this.$store.state.admin.users;
      },
      success(){
        return this.$store.state.admin.success
      },
      loading() {
        return this.$store.state.admin.loading
      },
      error() {
        return this.$store.state.admin.error
      }
  },
  created(){
    
  }
}
</script>

<style>

</style>